import { Registro_bienes } from './../../../models/registro_bienes.model';
import { Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';
declare var jQuery: any;
declare var $: any;


@Component({
    selector: "page-registro_bienes",
    templateUrl: "./registro_bienes.component.html",
    styleUrls: ["./registro_bienes.component.css"],
    providers: [FormService]
})

export class Registro_bienesComponent {

    public rows = [];
    public actualRow;
    public registro_bienes: Registro_bienes;
    public form;
    public fecha;
    public escritura;


    constructor(public _formService: FormService, private fb: FormBuilder) {
        this.form = new FormGroup({
            inscrito: new FormControl(''),
            numero: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
            anio: new FormControl('',[Validators.min(1850),Validators.max(new Date().getFullYear()),Validators.pattern(/[0-9]*/)]),
            bienes: new FormControl(''),
        })
        if (!JSON.parse(localStorage.getItem("registro_bienes"))) {
            localStorage.setItem("registro_bienes", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("registro_bienes"));

            this.form.controls['inscrito'].setValue(this.rows[0] ? this.rows[0].inscrito : '')
            this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '')
            this.form.controls['anio'].setValue(this.rows[0] ? this.rows[0].anio : '')
            this.form.controls['bienes'].setValue(this.rows[0] ? this.rows[0].bienes : '')
        }

    }

    add_registro() {
        localStorage.setItem("registro_bienes", JSON.stringify([]));
        this.actualRow = localStorage.getItem("registro_bienes");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            inscrito: this.form.value.inscrito,
            numero: this.form.value.numero,
            anio: this.form.value.anio,
            bienes: this.form.value.bienes
        })
        localStorage.setItem("registro_bienes", JSON.stringify(this.rows));
        console.log(this.registro_bienes)
    }

    delete_registro(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("registro_bienes", JSON.stringify(this.rows));
            }
        }
    }



}